import { BetTypes } from "../../../../types";
import { getDictPhrase } from "../../../common";
import { getOccurrenceProps, getMarketResultProps, getRuleDeductionProps } from "../../selection";
import { getEventNameAntePost } from "../getEventNameAntePost";
export const getEventDetailsAntePost = (betType, selection, state) => {
    return {
        eventName: getEventNameAntePost(selection),
        occurrence: getOccurrenceProps(selection.startEventDate, state, getDictPhrase(state.dict, "Starts")),
        marketResult: betType !== BetTypes.YourBet ? getMarketResultProps(selection, state) : undefined,
        ruleDeduction: selection.rule4Deduction ? getRuleDeductionProps(selection) : undefined
    };
};
//# sourceMappingURL=getEventDetailsAntePost.js.map